import { render, staticRenderFns } from "./points_order.vue?vue&type=template&id=630459ad&scoped=true"
import script from "./points_order.vue?vue&type=script&lang=js"
export * from "./points_order.vue?vue&type=script&lang=js"
import style0 from "./points_order.vue?vue&type=style&index=0&id=630459ad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630459ad",
  null
  
)

export default component.exports